module.exports = __webpack_public_path__ + "static/media/akra_logo_white_red.af66243f.svg";